import React, { useRef } from 'react';
import CommentIcon from '../../../core/assets/svg/comment-chat-svgrepo-com.svg';
import EarthIcon from '../../../core/assets/svg/earth-planet-svgrepo-com.svg';
import ProgramIcon from '../../../core/assets/svg/platform-program-svgrepo-com.svg';
import { motion } from 'framer-motion';
import clsx from 'clsx';


interface CategorySelectedProps {
    isSelected: boolean;
    type: "global" | "category" | "product";
    onClick: () => void;
}

const PromotionBlockSelected = (props: CategorySelectedProps) => {

    const { isSelected, type, onClick } = props;
    const divRef = useRef<HTMLDivElement>(null);

    const gradientTypes = {
        global: {
            icon: <img src={EarthIcon} alt="Earth Icon" className="w-20 h-20" />,
            title: "Global"
        },
        category: {
            icon: <img src={ProgramIcon} alt="Program Icon" className="w-20 h-20" />,
            title: "Categoría"
        },
        product: {
            icon: <img src={CommentIcon} alt="Comment Icon" className="w-20 h-20" />,
            title: "Producto"
        }
    };

    return (
        <div className="relative  p-2 flex justify-center ">
            {/* overflow-hidden */}
            <div
                className={`transsition-all absolute z-20 rounded-2xl overflow-hidden ${isSelected ? 'bg-gray-500' : 'hidden'}`}
                style={{
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    margin: 'auto',
                    // maxWidth: divRef.current?.offsetWidth + 8,
                    // maxHeight: divRef.current?.offsetHeight + 6,
                }}
            >
                <div
                    className={`z-40 relative ${isSelected ? 'gradient-border' : 'hidden'}`}
                    style={{
                        top: -150,
                        left: -150,
                        right: 0,
                        bottom: 0,
                        margin: 'auto',
                        width: divRef.current?.offsetWidth + 300,
                        height: divRef.current?.offsetHeight + 300,
                    }}
                >

                </div>
            </div>


            <motion.div
                ref={divRef}
                onClick={onClick}
                className={clsx(`z-30 promotion-block flex flex-col justify-center items-center rounded-xl w-[160px] p-2 bg-white relative cursor-pointer `,
                    {
                        "border-0 shadow-lg ": isSelected,
                        "border-2 border-principalColor": !isSelected
                    }
                )}

                whileHover={{ scale: isSelected ? 1.01 : 1.1, boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)" }}
                animate={{ scale: isSelected ? 1.01 : 1, boxShadow: isSelected ? "0px 10px 30px rgba(0, 0, 0, 0.2)" : "none" }}
                transition={{ type: "spring", stiffness: 300 }}
            >

                <span>{gradientTypes[type].icon}</span>
                <span className="mt-3 text-lg">{gradientTypes[type].title}</span>

            </motion.div >
        </div>

    );
};

export default PromotionBlockSelected;
